import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { format, subDays, setHours, setMinutes, setSeconds } from 'date-fns';
import { GFU } from '~/constants/perfil';

import { Report } from '~/components';
import { DateTime, Autocomplete, RadioGroup } from '~/components/Form';
import { isNull, isArray, concat, trim, isUndefined } from 'lodash';

import { toast } from 'react-toastify';
import * as Yup from 'yup';
import qs from 'querystring';
import api from '~/services/api';
import { parseDateString, t } from '~/helpers';

function Relabastecimentonoperiodovalor() {
  const [open, setOpen] = useState(true);

  //NOVOS CAMPOS


  const [valueProduto, setValueProduto] = React.useState(0);
  const [inputValueProduto, setInputValueProduto] = React.useState('');


  const [organ, setOrgan] = useState({ orga_codigo: '', orga_nome: '' });
  const [organDisable, setOrganDisable] = useState(false)

  const [unity, setUnity] = useState({ unid_codigo: '', unid_nome: '' });
  const [unityDisable, setUnityDisable] = useState(false)

  const datahorainicial = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(subDays(new Date(), 7), 0), 0), 0),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );

  const datahorafinal = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(new Date(), 23), 59), 59),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );

  const { profile } = useSelector((state) => state.user);

  async function handleValidate(param) {
    try {
      const schema = Yup.object().shape({
        datahorainicial: Yup.date()
          .typeError(t('s.geral.validacao.campoobrigatorio'))
          .transform((_, value) => parseDateString(value))
          .required(t('s.geral.validacao.campoobrigatorio')),
        datahorafinal: Yup.date()
          .typeError(t('s.geral.validacao.campoobrigatorio'))
          .transform((_, value) => parseDateString(value))
          .required(t('s.geral.validacao.campoobrigatorio'))
          .max(
            datahorafinal,
            `A data não pode ser superior a ${datahorafinal}`
          )
          .min(
            Yup.ref('datahorainicial'),
            'A data não pode ser inferior à data inicial'
          ),
      });

      await schema.validate(param, {
        abortEarly: false,
      });

      if (unityDisable && !unity.unid_codigo) {
        throw ('Este usuário não possui unidade(s) cadastrada(s) !')
      }
    } catch (err) {
      const form = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          form[error.path] = error.message.replace(`${error.path} `, '');
        });

        throw { form };
      } else {
        throw err
      }
    }
  }

  const handleValidOrgaos = useCallback(async () => {

    try {

      const { data } = await api.get('orgaos');

      if (data.items.length == 1) {
        let tempOrgan = data.items[0]

        setOrgan(tempOrgan)
        setOrganDisable(true)
      } else if (data.items.length == 0) {
        setOrgan({ orga_codigo: '', orga_nome: '' })
        setOrganDisable(true)
      } else {
        setOrganDisable(false)
      }

    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    }

  }, [])

  const handleValidUnidades = useCallback(async () => {

    try {
      const url = organDisable ? 'unidades/usuario' : 'unidades'
      const { data } = await api.get(url, {
        params: {
          wherefield: 'orga_codigo',
          valuewherefield: organ.orga_codigo,
          typewherefield: 'EQUALS',
          pagezie: 99999
        },
        paramsSerializer: (param) => qs.stringify(param)
      });

      if (data.items.length == 1) {
        const tempUnity = data.items[0]
        setUnity(tempUnity)
        setUnityDisable(true)
      } else if (data.items.length == 0) {
        setUnity({ unid_codigo: '', unid_nome: '' })
        setUnityDisable(true)
      } else {
        setUnityDisable(false)
      }

    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    }

  }, [organ])

  const handleChangeUnity = useCallback((value) => {
    if (isNull(value.unid_nome)) setUnity({ unid_codigo: '', unid_nome: '' });
    else setUnity(value);
  }, []);

  const handleChangeOrgan = useCallback((value) => {
    if (isNull(value.orga_nome)) setOrgan({ orga_codigo: '', orga_nome: '' });
    else {
      setOrgan(value);
      setUnity({ unid_codigo: '', unid_nome: '' });
    }
  }, []);

  useEffect(() => {
    handleValidOrgaos()
  }, [])

  useEffect(() => {
    handleValidUnidades()
  }, [organ])

  const onSerializeData = useCallback(
    (data) => {

      return {
        ...data,
        unidade: unity.unid_codigo ?? '',
        unidadestr: unity.unid_nome ?? '',
        orgao: organ.orga_codigo ? organ.orga_codigo : '',
        orgaostr: organ.orga_nome ? organ.orga_nome : '',
        produto: valueProduto ??  '',
        produtostr: inputValueProduto ??  '',
      };
    },
    [organ, unity, valueProduto]
  );

  return (
    <Report
      open={open}
      onClose={() => setOpen(false)}
      title="Consumo Combustível da Unidade no Período – Data"
      relatorio="consumocombustivelunidadeperiododata"
      validate={(param) => handleValidate(param)}
      serialize={onSerializeData}
      initials={{
        datahorainicial,
        datahorafinal,
        orgao: organ.orga_codigo,
      }}
    >
      <DateTime time label="Data Inicial" name="datahorainicial" disableFuture/>

      <DateTime time label="Data Final" name="datahorafinal" disableFuture/>

      <Autocomplete
        includeInputInList
        disabledItemsFocusable
        disableClearable={!organ.orga_nome}
        name="orgao"
        label="orga_nome"
        title="Órgão"
        url="orgaos"
        unique="orga_codigo"
        inputValue={organ.orga_nome}
        disabled={organDisable}
        getValue={handleChangeOrgan}
        onInputChange={(event, value) => {
          let obj = {
            ...organ,
            orga_nome: value,
          }
          setOrgan(obj);
        }}
      />

      <Autocomplete
        includeInputInList
        disabledItemsFocusable
        disableClearable={!unity.unid_codigo}
        name="unidade"
        label="unid_nome"
        title="Unidade"
        url="unidades/usuario"
        unique="unid_codigo"
        params={{
          wherefield: ['orga_codigo'],
          valuewherefield: [organ.orga_codigo],
          typewherefield: ['EQUALS'],
        }}
        disabled={isNull(organ.orga_codigo) || unityDisable}
        getValue={handleChangeUnity}
        inputValue={unity.unid_nome}
        onInputChange={(event, value) => {
          let obj = {
            ...unity,
            unid_nome: value,
          }
          setUnity(obj);
        }}
      />

      <Autocomplete
        name="prod_codigo"
        label="prod_descricao"
        title="Produto"
        id="prod_codigo"
        url="produtos"
        unique="prod_codigo"
        value={valueProduto}
        inputValue={inputValueProduto}
        onChange={(event, newValue) => {
          setValueProduto(newValue);
        }}
        onInputChange={(event, newInputValueProtudo) => {
          setInputValueProduto(newInputValueProtudo);
        }}
        defaultValue=""
        hiddens={[{ name: 'prod_descricao' }]}
        getValue={(value) => {
          if (value.prod_codigo !== null) {
            setValueProduto(value.prod_codigo);
          } else {
            setValueProduto(0);
          }
        }}
      />

      <RadioGroup
        name="tipo"
        label="Formato"
        options={[
          { label: 'PDF', value: 'pdf' },
          { label: 'Excel', value: 'xls' },
        ]}
        defaultValue="pdf"
        serialize={(value) => value}
        row
      />
    </Report>
  );
}

export default Relabastecimentonoperiodovalor;
